import React from "react";
import useRecalculateScoresOptions from "./recalculate-options.state";
import { CustomDeleteModal } from "../../DeleteModal/DeleteModal";
import "./index.scss";

const RecalculateScores = ({ isView = false }) => {
  const { options, modalState, isLoading } = useRecalculateScoresOptions();
  const { activeModalState, handleModalCancel, handleModalConfirm } = modalState;

  return (
    <div className="recalculate-scores-wrapper">
      <div className="heading mb-4">Recalculate Scores</div>
      <div className="options-wrapper">
        {options.map((option, index) => (
          <div key={index} className="option-wrapper">
            <div className="d-flex flex-column">
              <div className="title">{option.title}</div>
              <div className="subtitle">{option.description}</div>
            </div>
            {!isView && (
              <button className="connect-btn" onClick={option.onClick}>
                {option.buttonText}
              </button>
            )}
          </div>
        ))}
      </div>

      <CustomDeleteModal
        show={activeModalState?.show || false}
        hideModal={handleModalCancel}
        deleteHeaderIcon={null}
        deleteHeaderText={activeModalState?.config?.title || "Confirm Action"}
        deleteBodyText={activeModalState?.config?.message || "Are you sure you want to proceed?"}
        deleteFooterText=""
        deleteButtonClass="delete-btn"
        deleteFunction={handleModalConfirm}
        deleteParams={null}
        deleteType=""
        deleteButtonText="Yes, Proceed"
        isLoading={isLoading}
        customBody={null}
        refreshData={null}
        processingText="Processing..."
        callBack={null}
        paramId={null}
        callBackData={null}
        cancelButtonTitle="Cancel"
        cancelButtonFunction={null}
        dialogClassName=""
        backdropClassName=""
      />
    </div>
  )
}

export default RecalculateScores;
